import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { add } from 'date-fns';
import { DateService } from 'src/app/services/date.service';
import { StockService } from 'src/app/services/stock.service';
import { ToastService } from 'src/app/services/toast.service';
import { SignalElement, SignalsElement } from 'src/app/utils/signalsElements';
import { svgElement } from 'src/dictionaries/svg-sign';
import { DeviceSignalingEnum, ItemUnitEnum } from 'src/enumerators';
import { WarrantyTypeEnum } from 'src/enumerators/action.enum';
import { Contract, ContractDeviceItem, DeviceSignalingTaskActivities } from 'src/models';

@Component({
  selector: 'app-device-activity',
  templateUrl: './device-activity.component.html',
  styleUrls: ['../forms-styles.css'],
})
export class DeviceActivityComponent implements OnInit {
  deviceItems: ContractDeviceItem[] = [];
  signalsElements: SignalElement[] = Object.values(SignalsElement);
  itemUnitEnum = ItemUnitEnum;
  radioState = [];
  stockEntries: any[] = [];
  lastQuantity: number;
  quantityToBeRegistered: number;
  currentIndex: number;

  @Input() deviceSignalingTaskActivities: any[];
  @Input() contract: Contract;
  @Output() validationEvent = new EventEmitter<boolean>();
  @Input() isStock: boolean = false;
  @Output() addCode = new EventEmitter<{ code: string, index: number }>();
  @Output() removeCode = new EventEmitter<number>();

  today = new Date();

  constructor(
    public dateService: DateService,
    private _stockService: StockService,
    private _toastService: ToastService,
  ) { }
  ngOnInit(): void {
    this.contract?.deviceGroups.forEach((group) => {
      group.deviceItems.forEach((item: ContractDeviceItem) => {
        this.deviceItems.push(item);
      });
    });
    this.deviceSignalingTaskActivities.forEach((sign) => {
      this.radioState.push(
        sign.stockedDeviceSignalingId ? { stock: true, contract: false } : { stock: false, contract: true },
      );
      if (sign.contractDeviceItemId) {
        this.setContractItem(sign, undefined, undefined, true);
        this.setWarranty(sign.warranty, sign);

      }
      if (sign.id) {
        this.lastQuantity = sign.quantity;
      }
      sign['quantityToBeRegistered'] = sign.quantity;
    });

    this._stockService.getStockedDevice(this.contract.id).subscribe((res: any) => {
      this.stockEntries = res;
    });
  }

  verifyQuantity(index) {
    if (this.deviceSignalingTaskActivities[index].id && this.isStock) {
      if (this.deviceSignalingTaskActivities[index]?.quantityToBeRegistered >= this.lastQuantity) {
        this.deviceSignalingTaskActivities[index].quantity =
          this.deviceSignalingTaskActivities[index]?.quantityToBeRegistered;
      } else {
        this.deviceSignalingTaskActivities[index].quantityToBeRegistered = this.lastQuantity;
        this._toastService.showError('A quantidade não pode ser inferior às cadastradas.');
      }
    } else {
      this.deviceSignalingTaskActivities[index].quantity =
        this.deviceSignalingTaskActivities[index]?.quantityToBeRegistered;
    }
  }

  // Defini o item do contrato para autocomplete e calculo
  setContractItem(sign: DeviceSignalingTaskActivities, stockedId?: string, index?: number, edit?: boolean) {
    var item: any;
    if (!stockedId) {
      item = this.deviceItems.find((item) => item.id == sign.contractDeviceItemId);
      if (item.adjustedUnitValue) item.unitValue = item.adjustedUnitValue;
      sign.contractDeviceItem = item;

      if (!edit) {
        if (sign.contractDeviceItemId) {
          if (sign.contractDeviceItem.warrantyType == WarrantyTypeEnum.TimeInterval) {
            sign.warranty = add(new Date(), { years: sign.contractDeviceItem.warrantyYear, months: sign.contractDeviceItem.warrantyMonth })
          }
          else if(sign.contractDeviceItem.warranty) sign.warranty = new Date(sign.contractDeviceItem.warranty);
        }
      }

      sign['progress'] = 0;
      sign['active'] = 1;
      sign.deviceCode = item.signaling as DeviceSignalingEnum;
      sign['svg'] = svgElement.Signaling[item.signaling];
      if (sign.units || sign.dimension) this.setDeviceCost(sign);
      this.addCode.emit({ code: sign.deviceCode, index });
      return;
    };

    const signItem = this.deviceSignalingTaskActivities[index];
    const stockSign = this.stockEntries.find((item) => item.id == stockedId);
    item = this.stockEntries.find((item) => item.id == stockedId).contractDeviceItem;
    signItem.warranty = this.stockEntries.find((item) => item.id == stockedId).warranty;
    this.setWarranty(signItem.warranty, sign);
    signItem.contractDeviceItem = item;
    signItem.contractDeviceItemId = item.id;
    signItem.deviceCode = item.signaling as DeviceSignalingEnum;
    this.addCode.emit({ code: signItem.deviceCode, index });
    sign.units = stockSign.units;
    sign.dimension = stockSign.dimension;

    signItem['svg'] = svgElement.Signaling[item.signaling];
    if (signItem.units || signItem.dimension) this.setDeviceCost(signItem);
  }

  // Calcula e atribui valor à atividade
  setDeviceCost(sign: DeviceSignalingTaskActivities) {
    sign.cost =
      (sign.contractDeviceItem.unit == ItemUnitEnum.m ? sign.dimension : sign.units) *
      (this.isStock ? sign['quantity'] : 1) *
      sign.contractDeviceItem.unitValue;
  }

  // Remove a atividade
  removeActivity(index: number) {
    this.deviceSignalingTaskActivities.splice(index, 1);
    this.removeCode.emit(index);
  }

  // Seta a garantia da sinalização e barra de progresso
  setWarranty(event: Date, sign: DeviceSignalingTaskActivities) {
    sign['warrantyTextCurrent'] = null;
    sign['warrantyCurrent'] = null;
    sign['warrantyEnd'] = null;
    sign['progress'] = 0;
    sign['active'] = 1;
    sign.warranty = event;
    const relativeTime: any[] = this.dateService.getRelativeTime(event, new Date());
    sign['warrantyTextCurrent'] = this.dateService.getTextDate(relativeTime);
    this.progressWarranty(event, sign);
  }

  //Função par auxiliar na criação da barra de progresso de garantia
  progressWarranty(warranty, sign: DeviceSignalingTaskActivities) {
    let now = new Date();
    sign['warrantyEnd'] = this.dateService.getRelativeTime(warranty, now);
    sign['warrantyCurrent'] = this.dateService.getRelativeTime(warranty, now);

    if (sign['warrantyCurrent'][0] || sign['warrantyEnd'][0]) {
      sign['progress'] = sign['warrantyCurrent'][0] / sign['warrantyEnd'][0];
    } else {
      sign['progress'] = 0;
    }

    if (sign['progress'] <= 0) {
      sign['active'] = 3;
    } else {
      if (
        sign['warrantyCurrent'][1] <= 0 &&
        ((sign['warrantyCurrent'][2] <= 0 && sign['warrantyCurrent'][3] <= 31) ||
          (sign['warrantyCurrent'][2] == 1 && sign['warrantyCurrent'][3] == 0))
      ) {
        sign['active'] = 2;
      } else {
        sign['active'] = 1;
      }
    }
  }

  // Emite validação do form
  emitValidation(sign: any) {
    const validation = (sign.quantity > 0 && sign.deviceCode && (sign.units || sign.dimension));
    this.validationEvent.emit(validation);
  }

  setBond(type, index) {
    if (type == 'stock') {
      this.radioState[index] = { stock: true, contract: false };
    } else {
      this.radioState[index] = { stock: false, contract: true };
    }
  }
}
